import Swiper, {Autoplay, Pagination, Navigation, EffectFade} from 'swiper';
import LazyLoad from "vanilla-lazyload";
import contactPage from './contact';
import businessForm from './business';
import createDynamicForm from './fieldcreator';

function HomeInit(isMobileDevice) {
  Swiper.use([Autoplay, Pagination, EffectFade]);
  function loadLazyVideo(currentVideo, currentSlide) {
    let videoSource = currentVideo.children[0];
    if (videoSource.hasAttribute('src')) return;
    if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
      videoSource.src = videoSource.dataset.src;
    }
    // currentVideo.addEventListener('loadeddata', (e) => {
    //   if(currentVideo.readyState >= 3) {
    //     currentSlide.querySelector('.media-loader').classList.toggle('d-none')
    //   }
    // })
    currentVideo.load()
  }
  new Swiper('.homepage-swiper-grid', {
      loop: false,
      speed: 400,
      // autoplay: {
      //     delay: 3300,
      //     disableOnInteraction: false,
      // },
      autoplay: false,
      grabCursor: true,
      // nextButton: '.swiper-navigation-grid-next',
      // prevButton: '.swiper-navigation-grid-prev',
      pagination: {
        clickable: false,
        el: '.swiper-pagination-grid',
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          return `<div class="swiper-pagination-no"><span class="current">${current}</span><span class="separator"></span><span class="total">${total}</span></div>`
        }
      },
      on: {
        afterInit: function(s){
          let next = s.el.querySelector('.swiper-navigation-grid-next')
          let prev = s.el.querySelector('.swiper-navigation-grid-prev')
          next.addEventListener('click', () => {
            s.slideNext()
          });
          prev.addEventListener('click', () => {
            s.slidePrev()
          });
          let videos = s.el.querySelectorAll('video');
          let currentSlide = s.slides[s.activeIndex]
          if(!currentSlide) return
          let currentVideo = currentSlide.querySelector('video')
          if(currentVideo) {
            loadLazyVideo(currentVideo, currentSlide)
            currentVideo.play()
            currentVideo.onended = (e) => {
              if(s.slides.length > 1)
                s.slideTo(s.activeIndex + 1)
            }
            // let progressBar = currentSlide.querySelector("progress")
            // if(progressBar) {
            //   setInterval(function () {
            //     progressBar.value =
            //       Math.round((currentVideo.currentTime / (currentVideo.duration | 0)) * 100);
            //   });
            // }
            if(currentVideo.hasAttribute('data-audio')) {
              currentSlide.querySelector('.video-volume').addEventListener('click', function(e){
                e.preventDefault()
                e.currentTarget.querySelector('.video-volume-on').classList.toggle('d-none')
                e.currentTarget.querySelector('.video-volume-off').classList.toggle('d-none')
                currentVideo.muted = !currentVideo.muted
              })
            }
          }
        },
        transitionStart: function(s) {
          let videos = s.el.querySelectorAll('video');
          for (var i = 0; i < videos.length; i++) {
            videos[i].pause()
          }
        },
        transitionEnd: function(s) {
          // let videos = s.el.querySelectorAll('video');
          let currentSlide = s.slides[s.activeIndex]
          if(!currentSlide) return
          let currentVideo = currentSlide.querySelector('video')
          if(currentVideo) {
            loadLazyVideo(currentVideo, currentSlide)
            currentVideo.play()
            currentVideo.onended = (e) => {
              if(s.slides.length > 1)
                if(s.activeIndex != (s.slides.length - 1)) {
                  s.slideTo(s.activeIndex + 1)
                } else {
                  s.slideTo(0)
                }
            }
            // let progressBar = currentSlide.querySelector("progress")
            // if(progressBar)
            //   setInterval(function () {
            //     progressBar.value =
            //       Math.round((currentVideo.currentTime / (currentVideo.duration | 0)) * 100);
            //   });
          }
          let innerSwiperElement = currentSlide.querySelector('.swiper-swiper-grid')
          if(innerSwiperElement) {
            new Swiper(innerSwiperElement, {
              effect: 'fade',
              fadeEffect: { crossFade: true },
              virtualTranslate: true,
              noSwiping: true,
              slidesPerView: 1,
              autoplay: {
                delay: 3000,
                disableOnInteraction: true
              },
              navigation: {
                nextEl: '.swiper-swiper-button-next',
                prevEl: '.swiper-swiper-button-prev',
              },
            })
          }
        }
      }
  });

  new Swiper('.trip-ideas-slider', {
      slidesPerView: isMobileDevice ? 2 : 4,
      spaceBetween: 5,
      // fadeEffect: { crossFade: true },
      // navigation: {
      //   nextEl: ".swiper-tripideas-button-next",
      //   prevEl: ".swiper-tripideas-button-prev",
      // },
      speed: 450,
      loop: true,
      autoplay: {
        delay: 2100,
        disableOnInteraction: true,
      },
      on: {
        afterInit: function(s){
          let next = document.querySelector('.swiper-tripideas-button-next')
          let prev = document.querySelector('.swiper-tripideas-button-prev')
          next.addEventListener('click', () => {
            s.slideNext()
          });
          prev.addEventListener('click', () => {
            s.slidePrev()
          });
        }
      }
  });

  function onClassChange(element, callback) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class')
          callback(mutation.target)
      })
    })
    observer.observe(element, { attributes: true })
    return observer.disconnect
  }

  let tabs = [".tab-villas", ".tab-events", ".tab-yachts"]
  for (var i = 0; i < tabs.length; i++) {
    onClassChange(document.querySelector(tabs[i]).parentNode, (node) => {
      if(node.classList.contains('active') && node.classList.contains('show')) {
        if(!node.children[0].classList.contains('swiper-container-initialized')) {          
          new Swiper(node.children[0], {
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            effect: 'fade',
            speed: 500,
            spaceBetween: 0,
            autoplay: {
              delay: 1500,
              disableOnInteraction: false,
            }
          });
        }
      }
    })
    if(tabs[i] == '.tab-villas') {
      document.querySelector('#tab1').classList.add('show', 'active')
    }
  }
}


export function renderEnquireNowForm(action = "51fd62d5098ccfd99e2bf4c37bbfde74", selElement = '#dynamic-formapp')
{

  let excludeFields = null;
  // While on property page, we can hide 'Where do you want to go' field
  // todo
  if( getScreen() === 'property' ) {
      excludeFields = ['destination'];
  }

  createDynamicForm([
      {
          name: 'your_name',
          field: {
              type: 'input',
              field_type: 'text',
          },
          label: 'Your Name*',
          placeholder: 'Tell us your name',
          class: 'form-field-popup',
          required: true,
      },
      {
          column: [
              {
                  name: 'phone_number',
                  field: {
                      type: 'input',
                      field_type: 'text',
                      init: 'phone',
                  },
                  label: 'Your Phone Number',
                  placeholder: 'Including country code',
                  class: 'form-field-popup',
                  id: 'phone-number-area',
                  required: false,
              },
              {
                  name: 'email_address',
                  field: {
                      type: 'input',
                      field_type: 'email',
                  },
                  label: 'Your E-mail*',
                  placeholder: 'Your valid e-mail address',
                  class: 'form-field-popup',
                  required: true,
              },
              {
                  name: 'full_phone_number',
                  field: {
                      type: 'input',
                      field_type: 'hidden',
                  },
              },
              {
                  name: 'current_screen',
                  field: {
                      type: 'input',
                      field_type: 'hidden',
                      init: 'url',
                  },
              },
          ]
      },
      {
          name: 'check_in_out_dates',
          field: {
              type: 'input',
              field_type: 'text',
              init: 'calendar',
          },
          label: 'Check In & Check Out Dates *',
          placeholder: 'Click to choose your dates',
          class: 'form-field-popup',
          id: 'check-in-out-dates',
          required: false,
      },
      {
          name: 'number_guests',
          field: {
              type: 'input',
              field_type: 'number',
              min: '1',
          },
          label: 'Number of guests*',
          placeholder: 'Type number of total guests',
          class: 'form-field-popup',
          required: true,
      },
      {
          name: 'destination',
          field: {
              type: 'input',
              field_type: 'text',
          },
          label: 'Destination*',
          placeholder: 'Provide a destination/region name',
          class: 'form-field-popup',
          required: true,
      },
      {
          name: 'your_message',
          field: {
              type: 'textarea'
          },
          label: 'Additional informations',
          placeholder: 'Your message...',
          class: 'form-field-popup',
          required: false,
      },
  ], '/safeprocess/' + action, selElement, excludeFields);
}

function agentsPage() {
  createDynamicForm([
      {
        column: [
            {
                name: 'company_name',
                field: {
                    type: 'input',
                    field_type: 'text',
                },
                label: 'Company name*',
                placeholder: 'Type your company name',
                class: 'form-field-popup',
                required: true,
            },
            {
                name: 'your_name',
                field: {
                    type: 'input',
                    field_type: 'text',
                },
                label: 'Your name*',
                placeholder: 'Type your name',
                class: 'form-field-popup',
                required: true,
            }
        ]
      },
      {
        column: [
          {
              name: 'email_address',
              field: {
                  type: 'input',
                  field_type: 'email',
              },
              label: 'Your E-mail*',
              placeholder: 'Your valid e-mail address',
              class: 'form-field-popup',
              required: true,
          },
          {
              name: 'phone_number',
              field: {
                  type: 'input',
                  field_type: 'text',
                  init: 'phone',
              },
              label: 'Your Phone Number',
              placeholder: 'Including country code',
              class: 'form-field-popup',
              id: 'phone-number-area',
              required: false,
          },
        ]
      },
      {
        column: [
          {
            name: 'budget',
            field: {
                type: 'select',
            },
            label: 'Budget*',
            class: 'form-field-popup',
            required: true,
            opts: function(input) {
              let options = ["Choose your budget", "3-5k per night", "5-10k per night", "10k + per night (please specify)"]
              for (var i = 0; i < options.length; i++) {
                let optionEl = document.createElement('option')
                optionEl.innerText = options[i]
                optionEl.setAttribute('value', i)
                if(i == 0){
                  optionEl.setAttribute('disabled', 'disabled')
                  optionEl.setAttribute('selected', 'selected')
                }
                input.insertAdjacentElement('beforeend', optionEl)
              }
              input.addEventListener('change', (e) => {
                if(e.target.value === '3') {
                  let el = document.querySelector('input[name="budget_custom"]')
                  el.value = '10000'
                  let wrap = el.closest('.d-none')
                  if(wrap) wrap.classList.toggle('d-none')
                } else {
                  let el = document.querySelector('input[name="budget_custom"]')
                  el.value = '10000'
                  let wrap = el.closest('.row')
                  if(wrap) wrap.classList.add('d-none')
                }
              })
            }
          },
          {
            name: 'pref_currency',
            field: {
                type: 'select',
            },
            label: 'Currency*',
            class: 'form-field-popup',
            required: true,
            opts: function(input) {
              let currencies = ["USD", "EUR"]
              for (var i = 0; i < currencies.length; i++) {
                let optionEl = document.createElement('option')
                optionEl.innerText = currencies[i]
                optionEl.setAttribute('value', currencies[i])
                input.insertAdjacentElement('beforeend', optionEl)
              }
            }
          }
        ]
      },
      {
          name: 'budget_custom',
          field: {
              type: 'input',
              field_type: 'number',
              min: '10000'
          },
          label: 'Specify your budget*',
          class: 'form-field-popup',
          required: true,
          opts: function(input) {
            input.closest('.row').classList.toggle('d-none')
            input.value = '10000'
          }
      },
      {
        column: [
          {
              name: 'check_in_out_dates',
              field: {
                  type: 'input',
                  field_type: 'text',
                  init: 'calendar',
              },
              label: 'Check In & Check Out Dates *',
              placeholder: 'Click to choose your dates',
              class: 'form-field-popup',
              id: 'check-in-out-dates',
              required: false,
          },
          {
              name: 'number_guests',
              field: {
                  type: 'input',
                  field_type: 'number',
                  min: '1',
              },
              label: 'Number of guests*',
              placeholder: 'Type number of total guests',
              class: 'form-field-popup',
              required: true,
          },
          {
              name: 'full_phone_number',
              field: {
                  type: 'input',
                  field_type: 'hidden',
              },
          },
          {
              name: 'current_screen',
              field: {
                  type: 'input',
                  field_type: 'hidden',
                  init: 'url',
              },
          },
        ]
      },
      {
          name: 'destination',
          field: {
              type: 'input',
              field_type: 'text',
          },
          label: 'Destination*',
          placeholder: 'Provide a destination/region name',
          class: 'form-field-popup',
          required: true,
      },
      {
        name: 'guest_preferences',
        field: {
          type: 'input',
          field_type: 'checkbox',
          placeholder: 'Select any services or experiences the guests may be interested in:',
          choices: [
            "Private Chef",
            "Yacht / Boat Rental",
            "Chauffeur / Driver",
            "Butler",
            "Massage / Spa Services",
            "Fitness Trainer",
            "Childcare / Nanny",
            "Security",
            "Grocery Pre-stocking",
            "Daily Housekeeping",
            "Event / Wedding Planning",
          ],
          opts: function(fieldElement, checkboxes) {
            let x = document.createElement('input')
            x.setAttribute('type', 'hidden')
            x.setAttribute('name', 'preferences')
            fieldElement.insertAdjacentElement('beforeend', x)
            for (var i = 0; i < checkboxes.length; i++) {
              checkboxes[i].addEventListener('change', (e) => {
                let pref = document.querySelector('input[name="preferences"]')
                var data = {}
                if(pref.value.length > 0 ) {
                  data = JSON.parse(pref.value)
                }
                if(e.currentTarget.checked) {
                  data[e.currentTarget.value] = e.currentTarget.checked
                } else {
                  if(data.hasOwnProperty(e.currentTarget.value)) {
                    delete data[e.currentTarget.value]
                  }
                }
                pref.value = JSON.stringify(data)
              })
            }
          },
        },
        required: false
      },
      {
        name: 'other_notes',
        field: {
          type: 'textarea'
        },
        label: 'Other Specific requests/notes',
        placeholder: 'Provide guest preferences...',
        class: 'form-field-popup',
        required: false,
      },
  ], '/safeprocess/cf0482ac-f91d-46c6-9888-d34d392557eb', '#agentsForm');
}

/**
* Initialized all over the website
*/
function Global() {

  // Render content as tabs
  tabify({
      tabs: '.tinymce-cms-block .tab-ft-bar h5.headtitle a',
      tabsOuter: '.tinymce-cms-block h5.headtitle',
      tabsSection: '.tinymce-cms-block .tab-section'
  });

  let enquirePopup = document.querySelector('.enquire-popup-wrapper');

  if( ! isMobile() && ! isMicrosite() ) {
      let enquireButton = document.createElement('button');
          enquireButton.innerHTML = '<i></i>';
          enquireButton.classList.add('enquire-ribbon');
          enquireButton.style = 'position: fixed; top: 50%; border: 0px; right: 5px; z-index: 2000; width: 80px; height: 50px; box-shadow: 0 0 90px rgb(0 0 0 / 60%);';

      document.body.appendChild(enquireButton);

      enquireButton.addEventListener('click', function() {
          renderEnquireNowForm();
          enquirePopup.style.display = 'flex';
          document.body.style.overflow = 'hidden';
      });

      let seoReadMore = document.querySelector('#ft-click-readmore');
      let seoBoxContainer = document.querySelector('.gcrawler-box-container');
      if( seoReadMore ) {
          seoReadMore.addEventListener('click', function(e) {
              let readmoreEl = e.currentTarget;
              if( readmoreEl.getAttribute('expanded') === 'true' ) {
                  readmoreEl.setAttribute('expanded', 'false');
                  seoBoxContainer.style.height = '112px'
              } else {
                  readmoreEl.setAttribute('expanded', 'true');
                  seoBoxContainer.style.height = 'auto'
              }
          });
      }
  }

  let propertyEnquireBtn = document.querySelector('.email-manager-btn');
  let enquireAction = document.querySelectorAll('.btn-enquire-now-action')
  if( propertyEnquireBtn ) {
      propertyEnquireBtn.addEventListener('click', function() {
          renderEnquireNowForm();
          enquirePopup.style.display = 'flex';
          document.body.style.overflow = 'hidden';
      });
  }

  if(enquireAction.length > 0) {
    for (var i = 0; i < enquireAction.length; i++) {
      enquireAction[i].addEventListener('click', function() {
          renderEnquireNowForm();
          enquirePopup.style.display = 'flex';
          document.body.style.overflow = 'hidden';
      });
    }
  }

  let enquirePopupCloser = document.querySelector('.enquire-popup-closer');
  let dynamicForm = document.querySelector('#dynamic-formapp');
  let formAppMessage = document.querySelector('div[form-messager]');

  enquirePopupCloser.addEventListener('click', function() {
      enquirePopup.style.display = 'none';
      
      let picker = document.querySelector('div.flatpickr-calendar')
      if( picker ) picker.remove();

      document.body.style.overflow = '';
      dynamicForm.innerHTML = '';
      if( formAppMessage )
          formAppMessage.remove();
  })

}

// Transform an Youtube Link to Embed code.
function makeYoutubeEmbed(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  let match = url.match(regExp);
  return '<iframe width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/'+match[2]+'?controls=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
}

function Property() {

  let SwiperMainSlider,
      largeImgWrapper = document.querySelector('#property-medium-view img'),
      swiperTimer = document.createElement('div'),
      galleryWrapper = document.querySelector('.property-preview'),
      playable = document.querySelector('.featured-playable');

  if( playable ) {
      playable.addEventListener('click', function(e) {
          let target = e.currentTarget;
          let youtubeUri = target.getAttribute('youtube');
          let iframeEmbed = makeYoutubeEmbed(youtubeUri);
          let videoPopupWrapper = document.createElement('div');
              videoPopupWrapper.classList.add('video-popup-wrapper');
              videoPopupWrapper.innerHTML = iframeEmbed;
          
          let videoPopupCloser = document.createElement('button');
              videoPopupCloser.classList.add('video-popup-closer');
              videoPopupCloser.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="cadetblue" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"> <circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>';
          
          videoPopupCloser.addEventListener('click', function() {
              videoPopupWrapper.remove()
          });

          videoPopupWrapper.appendChild(videoPopupCloser);

          document.body.appendChild(videoPopupWrapper);
      });
  }

  Swiper.use([Autoplay, Navigation]);

  const SwiperMainSettings = {
      loop: false,
      spaceBetween: 10,
      autoplay: {
          delay: 3600,
          disableOnInteraction: false,
      },
      navigation: {
          nextEl: '.property-slider-button-next',
          prevEl: '.property-slider-button-prev',
      },
      on: {
          init: function () {
              let swiperImgs = document.querySelectorAll('.swiper-slide img');
              swiperImgs.forEach(function(e, k){
                  e.addEventListener('click', function(e){
                      e.preventDefault();
                      SwiperMainSlider.slideTo(k);
                  });
              });
          },
          slideChange: function (swiper) {
              let currentIndex = swiper.realIndex,
                  currentImg = swiper.slides[currentIndex],
                  largeSrc = currentImg.childNodes[0].getAttribute('data-src'),
                  getVideoAttr = document.querySelector('#property-medium-view img[has-video="true"]');

                  // if property has a video attached we need
                  // to show/hide the playable button only for first image from collection.
                  if( currentIndex !== 0 && getVideoAttr ) {
                      if( playable ) {
                          playable.classList.add('d-none')
                      }
                  } else {
                      if( playable ) {
                          playable.classList.remove('d-none')
                      }
                  }

                  // largeSrc = largeSrc.replace('-470x245', '');
                  largeSrc = largeSrc.replace('-150x150', '');

              largeImgWrapper.setAttribute('src', largeSrc);

          },
          reachEnd: function() {
             this.snapGrid = [...this.slidesGrid];
          },
      }
  }

  if( ! isMobile() ) {

      SwiperMainSettings.direction = 'vertical';
      SwiperMainSettings.slidesPerView = 4;
      SwiperMainSlider = new Swiper('.property-swiper-container', SwiperMainSettings);

      // Make the gallery expandable
      let expandableImage = document.querySelector('img[expandable="true"]'),
          galleryCloser = document.querySelector('.gallery-closer'),
          galleryThumbWrapper = document.querySelector('.property-thumbs'),
          galleryPreviewer = document.querySelector('#property-medium-view'),
          swiperContainer = document.querySelector('.property-swiper-container'),
          navBtns = document.querySelectorAll('button[slide-navigation]'),
          bodyElement = document.body,
          isExpanded = false;

      expandableImage.style.cursor = 'pointer';
      expandableImage.addEventListener('click', function(e) {

          if( isExpanded )
              return;

          // Once expandable, we can destroy the in site swiper
          // and initialize the horizontal version which gives 
          // us more room to do tha do.
          SwiperMainSlider.destroy(true, true);
          SwiperMainSettings.direction = 'horizontal';
          SwiperMainSettings.slidesPerView = 'auto';
          SwiperMainSettings.allowTouchMove = false;
          SwiperMainSlider = new Swiper('.property-swiper-container', SwiperMainSettings);

          bodyElement.style.overflow = 'hidden';  // disable scrolling in background
          expandableImage.style.cursor = 'inherit'; // remove pointer once is expanded.
          galleryWrapper.classList.add('gallery-expanded');
          swiperContainer.style.background = 'rgba(255,255,255,.09)';

          galleryThumbWrapper.classList.toggle('is-insite');

          navBtns.forEach(function(navBtn) {
              navBtn.classList.toggle('ui-none')
          })

          // Retrieve top position of gallery wrapper so we can
          // bring the aside thumbnails at the same level
          if( ! isExpanded )
              calculateSlidePosition(galleryThumbWrapper, e.currentTarget)

          isExpanded = true;
      });

      // Once is clicked, it will remove the expanded statement,
      // and return the slideable area back to its origin.
      galleryCloser.addEventListener('click', function(e){
          SwiperMainSlider.destroy(true, true);
          SwiperMainSettings.direction = 'vertical';
          SwiperMainSettings.slidesPerView = 4;
          SwiperMainSlider = new Swiper('.property-swiper-container', SwiperMainSettings);

          galleryThumbWrapper.classList.toggle('is-insite');
          navBtns.forEach(function(navBtn) {
              navBtn.classList.toggle('ui-none')
          })

          swiperTimer.innerHTML = '';

          bodyElement.style.overflow = 'inherit'; // enable scrolling
          galleryWrapper.classList.remove('gallery-expanded');
          swiperContainer.style.background = '#eee';
          expandableImage.style.cursor = 'pointer'; // make expandable image as being clickable
          isExpanded = false;
      })

  // Initialize Swiper Slider for mobile devices
  // with the minimal settings.
  } else {
      SwiperMainSlider = new Swiper('.property-mobile-swiper-container', {
          loop: false,
          autoplay: {
              delay: 3500,
              disableOnInteraction: false,
          },
          pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
      });
  }

  // Render content as tabs
  tabify({
      tabs: '.villa-tab-system li a',
      tabsOuter: '.villa-tab-system li',
      tabsSection: '.tab-section'
  });

}

// Recalculate positions if the window is resized.
function calculateSlidePosition(thumbWrapper, expandableImg) {
  let currentOffset = getOffset(expandableImg);
  // thumbWrapper.style.bottom = currentOffset.top + 'px';
  // thumbWrapper.style.left = currentOffset.left + expandableImg.clientWidth + 40 + 'px';
  // thumbWrapper.style.right = '120px';
}

const getOffset = function(element) {
  let top = 0, left = 0;
  do {
      top += element.offsetTop  || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
  } while(element);

  return {top: top, left: left};
};

/**
* Create simple tabs for given elements
* 
* @param string tabify
* @return void
*/
function tabify(tabify) {
  let tabs = document.querySelectorAll(tabify.tabs);
  for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function(e) {
          
          let el = e.currentTarget.parentNode;
          if( ! el.classList.contains('active-tab') ) {
              
              let current = document.querySelector( tabify.tabsOuter + '.active-tab');
              current.classList.remove('active-tab');
          
              let tabSection = document.querySelector(tabify.tabsSection + '.visible-tab');
              tabSection.classList.remove('visible-tab');

              let activeTab = e.currentTarget.getAttribute('rel');
              activeTab = document.querySelector('.' + activeTab);
              
              activeTab.classList.add('visible-tab');
              el.classList.add('active-tab');
          }
      })
  }
}

/**
* Make an element sticky
*/
const CSS_CLASS_ACTIVE = 'is-fixed';
const StickyElement = {
  element: null,
  position: 0,
  addEvents: function() {
      window.addEventListener('scroll', this.onScroll.bind(this));
  },
  init: function(element) {
      this.element = element;
      this.addEvents();
      this.position = element.offsetTop ;
      this.onScroll();
  },
  aboveScroll: function() {
      return this.position < window.scrollY;
  },
  onScroll: function(event) {
  
      if (this.aboveScroll()) {
          this.setFixed();
      } else {
          this.setStatic();
      }
  },
  setFixed: function() {
      this.element.classList.add(CSS_CLASS_ACTIVE);
      // not needed if added with CSS Class
      this.element.style.position = 'fixed';
      this.element.style.top = 0;
      this.element.style.marginTop = '0';
  },
  setStatic: function() {
      this.element.classList.remove(CSS_CLASS_ACTIVE);
      // not needed if added with CSS Class
      this.element.style.position = 'static';
      this.element.style.top = 'auto';
      this.element.style.marginTop = '5px';
  }
}


/**
* Retrieve current screen URL
* 
* @param  {String} screen
* 
* @return {Boolean}
*/
export const getScreen = () => {
  return document.body.getAttribute('current-screen');
}

/**
* Determine if current page is served via mobile.
* 
* @return {Boolean}
*/
function isMobile() {
  let attr = document.body.getAttribute('screen-type');
  if( attr && attr === 'mobile' )
    return true;
  return false;
}

/**
* Determine if current page is via microsite
* @return {Boolean}
*/
function isMicrosite() {
  let attr = document.body.getAttribute('is-microsite');
  if( attr && attr === 'true' )
      return true;
  return false;
}

export function init() {
  if( getScreen() === 'property' ) {
      Property()
  };
  new LazyLoad();
  let navigation = document.querySelector('#main-menu');
  if (navigation) StickyElement.init(navigation)
  // Initialize Homepage
  getScreen() == 'homepage' ? HomeInit(isMobile()) : null;
  // Initialize the form while on contact page
  getScreen() === 'contact' ? contactPage() : null;
  getScreen() === 'agents' ? agentsPage() : null;
  // Initialize the form while on business page
  getScreen() === 'partners' ? businessForm() : null;
  // Initialize Globals
  Global();
} 